import { ErrorHandler, Injectable } from '@angular/core'

/**
 * Meldungen der Browser, wenn ein nachgeladener Programmteil (Lazy-Chunk) fehlt: Chromium/Edge,
 * Firefox, Safari. Passiert in einem Tab, der einen Deploy ueberlebt hat — Edge friert schlafende
 * Tabs ein, statt sie wie Chrome neu zu laden, und die alten Chunk-Namen gibt es dann nicht mehr.
 */
const FEHLENDER_CHUNK =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i

/** Merker gegen eine Neulade-Schleife, falls der Chunk auch nach dem Neuladen fehlt. */
const NEU_GELADEN_KEY = 'saniup-chunk-neu-geladen'
const NEU_LADEN_SPERRE_MS = 60_000

@Injectable()
export class GlobalErrorHandlerService extends ErrorHandler {
  override handleError(error: unknown): void {
    console.error(error)
    if (istFehlenderChunk(error)) {
      neuLadenEinmal()
    }
  }
}

function istFehlenderChunk(error: unknown): boolean {
  const meldung = error instanceof Error ? error.message : String(error)
  return FEHLENDER_CHUNK.test(meldung)
}

/**
 * Laedt die Seite neu, damit sie den aktuellen Stand holt. Ohne das tat ein Klick sichtbar gar
 * nichts. Hoechstens einmal je Minute, und ohne sessionStorage (privates Fenster, Richtlinie)
 * lieber gar nicht als in einer Schleife.
 */
function neuLadenEinmal(): void {
  try {
    const zuletzt = Number(sessionStorage.getItem(NEU_GELADEN_KEY) ?? 0)
    if (Date.now() - zuletzt < NEU_LADEN_SPERRE_MS) {
      return
    }
    sessionStorage.setItem(NEU_GELADEN_KEY, String(Date.now()))
  } catch {
    return
  }
  location.reload()
}
